import React from 'react'
import { Flex } from 'antd'
import './index.css'

const UnderlineDesign = () => {
  return (
    <Flex align='center' gap={8}>
        <div className="line"></div>
        <div className="smdots"></div>
        <div className="smdots"></div>
        <div className="line"></div>
    </Flex>
  )
}

export {UnderlineDesign}